import { createContext, useContext, useState, useCallback } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import "./toast.css";

const ToastContext = createContext();

export const ToastProvider = ({ children, defaultDelay = 5000 }) => {
    const [toasts, setToasts] = useState([]);
    const variantMap = {
        success: "success",
        error: "danger",
        warning: "warning",
        info: "info",
        danger: "danger",
    };

    const showToast = useCallback(
        (message, variant = "success", delay) => {
            const id = Date.now(); 
            variant = variantMap[variant] || variant; 
            setToasts((prev) => [{ id, message, variant, delay }, ...prev].slice(0, 5));
        },
        [defaultDelay]
    );

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <ToastContainer className="custom-toast-container">
                {toasts.map(({ id, message, variant, delay }) => (
                    <Toast
                        key={id}
                        delay={delay}
                        autohide
                        onClose={() => removeToast(id)}
                        className={`custom-toast ${variant}`}
                    >
                        <div className="toast-header-bar">
                            <button
                                className="toast-close-btn"
                                onClick={() => removeToast(id)}
                                aria-label="Close"
                            >
                                x
                            </button>
                        </div>
                        <Toast.Body>{message}</Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>
        </ToastContext.Provider>
    );
};

export const useToast = () => useContext(ToastContext);
